import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'lib-bo-auth-social-button',
  standalone: true,
  templateUrl: './bo-auth-social-button.component.html',
  styleUrls: ['./bo-auth-social-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoAuthSocialButtonComponent {
  readonly label = input.required<string>();
  readonly ariaLabel = input('social auth button');
  readonly pressed = output<void>();
}
